<base-dialog>
  <div title>
    <h2>ESTABLECIMIENTO</h2>
  </div>

  <div close>
    <button mat-icon-button color="warn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div content>
    <form name="form" *ngIf="form" [formGroup]="form" autocomplete="off">
      <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon
          *ngIf="!image || image === ''"
          class="photo"
          [ngClass]="{ 'error-icon': imageHasError() }"
        >
          add_a_photo
        </mat-icon>
        <div class="imagePreview" *ngIf="image && image !== ''">
          <img [src]="image" />
        </div>
        <button mat-button type="button" (click)="fileUpload.click()">
          Cambiar
        </button>
        <input
          type="file"
          accept="image/*"
          (change)="onFileSelected($event)"
          [hidden]="true"
          #fileUpload
        />
        <div *ngIf="imageHasError()" class="error-message">
          {{ notification.image }}
        </div>

        <mat-form-field appearance="outline" class="inputNombre">
          <mat-label>Nombre comercial</mat-label>
          <input matInput formControlName="tradeName" />
          <mat-icon
            matSuffix
            class="secondary-text"
            [matTooltip]="notification.tradeName"
            [ngClass]="{ 'error-icon': tradeNameHasError() }"
          >
            class
          </mat-icon>
          <mat-error *ngIf="tradeNameHasError()" class="error-message">
            {{ notification.tradeName }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div actions class="btnContent">
    <button
      mat-raised-button
      (click)="submit()"
      [disabled]="!areAllFieldsValid() || isLoading"
      color="primary"
    >
      <div class="loadingComponent" *ngIf="isLoading">
        <app-loading
          [isLoading]="isLoading"
          class="loadingComponent"
        ></app-loading>
      </div>
      <span *ngIf="!isLoading">{{ txtBtn }}</span>
    </button>
  </div>
</base-dialog>
